import { Injectable } from '@angular/core';
import { SessionService } from '../helpers';
import jwt_decode from 'jwt-decode';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import * as moment from 'moment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(
    private sessionService: SessionService,
    private auth0Service: Auth0Service,
    private router: Router
  ) {}
  private refreshTokenTimeout: any;

  /**
   * Get new token
   */
  refreshToken() {
    this.auth0Service.getAccessTokenSilently().subscribe(async (data: any) => {
      if (data) {
        this.sessionService.setApplicationToken(data);
        await this.stopRefreshTokenTimer();
        await this.startRefreshTokenTimer();
      }
    });
  }

  /**
   * Check session is active or not.
   */
  checkSession(startRefresh?) {
    let appToken: any = this.sessionService.getApplicationToken();
    if (appToken) {
      let decoded: any = jwt_decode(appToken);
      let isExpTimePassed = moment().isAfter(moment.unix(decoded?.exp), 'seconds');
      if (isExpTimePassed) {
        this.stopRefreshTokenTimer();
        this.router.navigate(['/logout']);
      }
      let secondsLeftToRefresh: any = moment.unix(decoded?.exp).diff(moment(), 'seconds');
      if (secondsLeftToRefresh <= 30 && secondsLeftToRefresh > 1) {
        this.refreshToken();
      } else if (secondsLeftToRefresh > 30 && startRefresh) {
        this.startRefreshTokenTimer();
      } else if (secondsLeftToRefresh <= 1) {
        this.stopRefreshTokenTimer();
        this.router.navigate(['/logout']);
      }
    } else {
      this.stopRefreshTokenTimer();
      this.router.navigate(['/logout']);
    }
  }

  /**
   * Start refresh token timer
   */
  startRefreshTokenTimer() {
    return new Promise((resolve) => {
      let decoded: any = this.getDecodedToken();
      // set a timeout to refresh the token a minute before it expires
      const expires = new Date(decoded.exp * 1000);
      const timeout = expires.getTime() - Date.now() - 60 * 1000;
      this.refreshTokenTimeout = setTimeout(() => this.refreshToken(), timeout);
      resolve(true);
    });
  }

  /**
   * Stop refresh token timer
   */
  stopRefreshTokenTimer() {
    return new Promise((resolve) => {
      clearTimeout(this.refreshTokenTimeout);
      resolve(true);
    });
  }

  /**
   * Get decoded token
   */
  getDecodedToken() {
    let appToken: any = this.sessionService.getApplicationToken();
    let decodedToekn: any = jwt_decode(appToken);
    return decodedToekn;
  }

  /**
   * Check superadmin
   */
  checkSuperAdmin() {
    let decodedToken: any = this.getDecodedToken();
    if (decodedToken?.user_roles && Object.keys(decodedToken?.user_roles).length) {
      let userRoles: any = decodedToken?.user_roles;
      for (const key in userRoles) {
        let roleValue: any = userRoles[key];
        if (key.toLowerCase() == 'sso' && roleValue.includes('superadmin')) {
          return true;
        }
      }
    }
    return false;
  }
}
